<div class="portal-shell">
  <router-outlet></router-outlet>
</div>